import { render } from "./googleSingupComponent.vue?vue&type=template&id=0352ad7a"
import script from "./googleSingupComponent.vue?vue&type=script&lang=js"
export * from "./googleSingupComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__